/**
 * Created by razial on 28.12.2023
 */

GitManager.EDITORS = {
    location: {
        apply: function (data) {
            const locationId = data.locationId;
            const bundleId = data.bundleId || `location_${locationId}`;

            const link = bundles[bundleId].jsons.map_json.resolve();
            const content = { ...link.getJson(), ...data.content };

            link.setJsonData(content);

            cleverapps.git.urls[link.originalPath()] = content;

            const changes = {};
            changes[link.originalPath()] = {
                locationId,
                bundleId,
                content
            };

            return changes;
        },

        load: function (file, data) {
            this.apply(data);
        },

        cache: function (data) {
            const locationId = data.locationId;
            const bundleId = data.bundleId || `location_${locationId}`;

            const link = bundles[bundleId].jsons.map_json.resolve();

            const cached = {};
            cached[link.originalPath()] = {
                locationId,
                bundleId,
                content: { ...link.getJson() }
            };

            return cached;
        },

        restore: function (file, data) {
            this.apply(data);
        },

        getBundleNames: (data) => [data.bundleId || `location_${data.locationId}`]
    },

    episode: {
        apply: function (data) {
            const episodeNo = data.episodeNo;
            const language = data.language;
            let content = data.content;

            const info = this.prepare(data);
            const bundleName = info.bundleName;
            const levels = info.levels;
            const file = info.file;

            let bundle = bundles[bundleName];

            const processNew = !bundle;
            const processDelete = content === null;

            if (processNew) {
                bundle = bundles[bundleName] = {
                    frames: {},
                    jsons: { levels },
                    urls: { },
                    meta: {
                        originalPaths: {
                            levels: file
                        }
                    }
                };
            }

            if (processDelete) {
                delete bundles[bundleName];
                delete cleverapps.bundleLoader.handles[bundleName];
                delete cleverapps.git.urls[file];
            } else {
                content = content.levels ? content : { levels: content };

                const episodeLevels = content.levels.map((level) => (Array.isArray(level) ? level[level.length - 1] : level));

                bundle.meta = {
                    originalPaths: bundle.meta.originalPaths,
                    episode: {
                        episodeNo,
                        language: language || undefined,
                        levelsAmount: episodeLevels.length,
                        levels: episodeLevels.map((level) => {
                            let enemies;

                            if (cleverapps.config.rpg && level.goals && level.goals.length) {
                                enemies = level.goals.map((goal) => goal.type);
                            }

                            return {
                                tag: level.tag || undefined,
                                bundles: level.bundles && level.bundles.length && level.bundles || undefined,
                                units: level.units || undefined,
                                tiles: level.tiles || undefined,
                                mapSize: level.map && {
                                    width: level.map[0].length,
                                    height: level.map.length
                                } || undefined,
                                enemies: enemies || undefined
                            };
                        })
                    }
                };

                bundle.meta.stored = true;
                bundle.meta.debug = content.debug || undefined;

                const compact = Object.keys(content).filter((key) => content[key] !== undefined).length < 2;

                if (compact) {
                    content = content.levels;
                }

                cleverapps.git.urls[file] = content;

                if (processNew) {
                    bundles[bundleName] = new Bundle(bundleName, bundle);
                }
            }

            const changes = {};
            changes[file] = {
                episodeNo,
                language,
                content
            };

            return changes;
        },

        load: function (file, data) {
            this.apply(data);
        },

        cache: function (data) {
            const info = this.prepare(data);
            const bundleName = info.bundleName;
            const levels = info.levels;
            const file = info.file;

            const bundle = bundles[bundleName];
            const content = cc.loader.cache[levels];

            const cache = {
                bundleName,
                bundleContent: bundle ? bundle.save() : null,
                levelsUrl: levels,
                levelsContent: content ? JSON.parse(JSON.stringify(content)) : undefined
            };

            if (bundle && !cleverapps.bundleLoader.isLoaded(bundleName)) {
                cleverapps.bundleLoader.loadBundle(bundleName, {
                    onSuccess: function () {
                        const newBundle = bundles[bundleName];
                        const newContent = newBundle && cc.loader.cache[newBundle.jsons.levels];
                        if (newContent) {
                            cache.levelsContent = JSON.parse(JSON.stringify(newContent));
                        }
                    }
                });
            }

            const cached = {};
            cached[file] = cache;

            return cached;
        },

        restore: function (file, data) {
            if (data.bundleContent === null) {
                delete bundles[data.bundleName];
            } else {
                bundles[data.bundleName].parse(data.bundleContent);
            }

            cc.loader.cache[data.levelsUrl] = data.levelsContent;
            delete cleverapps.git.urls[data.levelsUrl];
        },

        prepare: function (data) {
            const episodeNo = data.episodeNo;
            const language = data.language;

            const bundleName = AdminEpisode.BundleId(episodeNo, language);
            const bundle = bundles[bundleName];

            let levels, file;

            if (!bundle) {
                levels = `${bundleName}#levels`;

                file = bundles.episode_0.jsons.levels.originalPath();
                file = file && file
                    .replace("/levels/en/", `/levels/${language}/`)
                    .replace("/0.json", `/${episodeNo}.json`);
            } else {
                levels = bundle.jsons.levels;
                file = levels.originalPath();
            }

            if (!file && cleverapps.config.levelsPath) {
                const languageFolder = cleverapps.config.type === "board" ? `${language}/` : "";
                file = `${cleverapps.config.levelsPath}${languageFolder}${episodeNo}.json`;
            }

            if (!file) {
                throw `Can't find file path for episode ${episodeNo} json`;
            }

            return {
                bundleName,
                levels,
                file
            };
        },

        getBundleNames: (data) => [AdminEpisode.BundleId(data.episodeNo, data.language)],

        getValidateError: function (data) {
            const errors = [];

            for (let i = 0; i < data.length; i++) {
                const level = new AdminLevel(data[i]);

                if (!(/\d+/.test(level.episodeNo))) {
                    return;
                }

                const err = level.getValidateError();

                if (err) {
                    errors.push(`Episode ${level.episodeNo}, Level ${level.getHumanNumber()}:\n${err}`);
                }
            }

            return errors.length > 0 ? errors : undefined;
        }
    },

    anchors: {
        apply: function (data) {
            const stage = data.stage;
            const urls = data.urls;

            const bundle = bundles[urls[stage].bundle];
            const res = bundle.jsons[urls[stage].key] || bundle.frames[urls[stage].key];

            bundle.meta = bundle.meta || {};
            bundle.meta.anchors = bundle.meta.anchors || {};
            bundle.meta.anchors[res.key] = bundle.meta.anchors[res.key] || {};

            if (cleverapps.config.type === "merge" && cleverapps.meta.selectedLocationId() === "main" && bundle.meta.anchors[res.key].podium) {
                bundle.meta.anchors[res.key].podium.x = data.anchorX;
                bundle.meta.anchors[res.key].podium.y = data.anchorY;
            } else {
                bundle.meta.anchors[res.key].x = data.anchorX;
                bundle.meta.anchors[res.key].y = data.anchorY;
            }

            const info = this.prepare(data);

            const changes = {};
            changes[info.file] = {
                stage: data.stage,
                urls: data.urls,
                content: info.content
            };

            return changes;
        },

        load: function (file, data) {
            this.restore(file, data);
        },

        cache: function (data) {
            const info = this.prepare(data);

            const changes = {};
            changes[info.file] = {
                stage: data.stage,
                urls: data.urls,
                content: info.content
            };

            return changes;
        },

        restore: function (file, data) {
            const urls = data.urls;
            const content = data.content;

            urls.forEach((url, stage) => {
                const bundle = bundles[url.bundle];
                const res = bundle.jsons[url.key] || bundle.frames[url.key];

                const anchors = content[`stage${stage + 1}`];

                if (anchors) {
                    bundle.meta = bundle.meta || {};
                    bundle.meta.anchors = bundle.meta.anchors || {};
                    bundle.meta.anchors[res.key] = bundle.meta.anchors[res.key] || {};
                    bundle.meta.anchors[res.key].x = anchors.x;
                    bundle.meta.anchors[res.key].y = anchors.y;
                }
            });
        },

        prepare: function (data) {
            const stage = data.stage;
            const urls = data.urls;

            const bundle = bundles[urls[stage].bundle];
            const res = bundle.jsons[urls[stage].key] || bundle.frames[urls[stage].key];

            const file = res.originalPath().replace(/\/stage.*/, "/anchors.json");
            const content = {};

            urls.forEach((url, stage) => {
                const bundle = bundles[url.bundle];
                const res = bundle.jsons[url.key] || bundle.frames[url.key];
                const originalPath = res.originalPath();
                const stageFile = originalPath && originalPath.replace(/\/stage.*/, "/anchors.json");

                if (stageFile === file) {
                    bundle.meta = bundle.meta || {};
                    bundle.meta.anchors = bundle.meta.anchors || {};
                    bundle.meta.anchors[res.key] = bundle.meta.anchors[res.key] || {};

                    if (bundle.meta.anchors[res.key].x === undefined) {
                        bundle.meta.anchors[res.key].x = 0.5;
                    }

                    if (bundle.meta.anchors[res.key].y === undefined) {
                        bundle.meta.anchors[res.key].y = 0.5;
                    }

                    content[`stage${stage + 1}`] = cleverapps.clone(bundle.meta.anchors[res.key], true);
                }
            });

            return {
                file,
                content
            };
        },

        getBundleNames: (data) => [...new Set(Object.values(data.urls).map((url) => url.bundle))]
    },

    scenario: {
        apply: function (data) {
            const file = data.file;
            const content = data.content;

            cleverapps.git.urls[file] = content;

            const changes = {};
            changes[file] = {
                file,
                content
            };

            return changes;
        },

        load: function (file, data) {
            if (data.content === null) {
                delete cleverapps.git.urls[file];
            } else {
                cleverapps.git.urls[file] = data.content;
            }
        },

        cache: function (data) {
            const cached = {};
            cached[data.file] = {};

            return cached;
        },

        restore: function (file) {
            delete cleverapps.git.urls[file];
        }
    }
};
